module.exports = __webpack_public_path__ + "img/提问.9bd9fac0.gif";